<template>
  <v-dialog
    v-model="isDialogOpen"
    max-width="600"
    content-class="fixed-height-md"
  >
    <HtmlSnippets
      title="Choose Snippet"
      sms
      :inside-quill="false"
      :contact-id="contactId"
      @insert="sendSMS"
      @close="isDialogOpen = false"
    />
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex';
import HtmlSnippets from '@/components/formFields/modals/HtmlSnippets.vue';

export default {
  name: 'RecruitChooseSnippetDialog',
  components: {
    HtmlSnippets,
  },
  props: {
    contactId: String,
    value: Boolean,
  },
  computed: {
    ...mapGetters(['singleContact']),
    isDialogOpen: {
      get() {
        return this.value;
      },
      set() {
        this.$emit('input', false);
      },
    },
  },
  methods: {
    sendSMS(compiledMessage) {
      this.$emit('sendSMS', compiledMessage);
    },
  },
};
</script>
